import "./Home.module.css";
import PrimaryStationHeader from "@/reusable_sections/Header";
import FuelYourStrengthHero from "./sections/FuelYourStrengthHero";
import VoicesFromOurCommunity from "./sections/VoicesFromOurCommunity";
import CoreTrainingAreas from "./sections/CoreTrainingAreas";
import EssentialPerformanceGear from "./sections/EssentialPerformanceGear";
import JoinTheMovement from "./sections/JoinTheMovement";
import FooterEcho from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <PrimaryStationHeader />
      <FuelYourStrengthHero />
      <VoicesFromOurCommunity />
      <CoreTrainingAreas />
      <EssentialPerformanceGear />
      <JoinTheMovement />
      <FooterEcho />
    </div>;
}